import { observer } from 'mobx-react-lite'
import { type IRow, Avatar, Button, Icon, Tooltip, Typography } from 'shared/ui'
import { type IUser } from 'entities/Users'
import { type IGoogleCalendarAccount } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationGoogleCalendarSettings/store/IntegrationGoogleCalendarSettingsStore'
import { IntegrationSettingsUsersCell } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/IntegrationSettingsUsers/IntegrationSettingsUsersCell'
import styles from './styles.module.scss'

type IGoogleCalendarAccountCellProps = {
  account: IGoogleCalendarAccount
}

export const GoogleCalendarAccountCell = observer(
  ({ account }: IGoogleCalendarAccountCellProps) => (
    <div className={styles.account}>
      <Avatar info={account.avatarInfo} size={32} />
      <div className={styles.content}>
        <div className={styles.accountName}>
          <Typography variant={'body-md-regular'} ellipsis ariaLabel={'accountName'}>
            {account.name}
          </Typography>
          {account.shouldReconnect ? (
            <Tooltip
              label='Calendar access expired. User needs to reconnect it in Profile settings.'
              placement='top'
              breakWord
            >
              <Icon icon='closeCircle' color='var(--red-60)' fontSize={12} />
            </Tooltip>
          ) : (
            <Icon icon='check2' color='var(--green-60)' fontSize={12} />
          )}
        </div>
        <Typography
          variant={'body-sm-regular'}
          ellipsis
          ariaLabel={'accountEmail'}
          color={'tertiary'}
        >
          {account.email}
        </Typography>
      </div>
    </div>
  )
)

type IGoogleCalendarAccountMappingCellProps = {
  account: IRow<IGoogleCalendarAccount>
  members: IUser[]
  onUserChange: (accountId: number, userId: number) => void
  onDisconnect: (accountId: number) => void
  disconnectLoading?: boolean
}

export const GoogleCalendarAccountMappingCell = observer(
  ({
    account,
    members,
    onUserChange,
    onDisconnect,
    disconnectLoading,
  }: IGoogleCalendarAccountMappingCellProps) => (
    <div className={styles.mapping}>
      <IntegrationSettingsUsersCell
        row={account}
        members={members}
        onUserChange={(accountId, memberId) => onUserChange(accountId, memberId)}
        showInvite={false}
        size={'small'}
        searchPlaceholder={'Search member'}
      />
      <Button
        text={'Disconnect'}
        typeBtn={'outlined'}
        contained={'secondary'}
        color={'tertiary'}
        onClick={() => onDisconnect(account.id)}
        disabled={disconnectLoading}
      />
    </div>
  )
)
